export const periods = [
    '2026-07-13',
    '2026-07-20',
    '2026-07-27',
    '2026-08-03',
];

export const dishes = [
    '5300', '5460', '5457', '5455', '4150', '4402',
];
